module.exports = __webpack_public_path__ + "img/2024-10-16a_2.606c8cc9.jpg";